/* Cadeaukaartpagina /pages/cadeaukaart (sections/page-cadeaukaart.liquid, 04-10-2026).
   1. Bedragkeuze in de bestelkaart: de kaartjes en de regel "Je betaalt ... Je ontvangt ... + ... bonus" volgen
      het gekozen bedrag (data-prijs, data-bonus op de keuzerondjes). Zonder bonus verdwijnt de bonusregel.
   2. In de winkelwagen zonder de pagina te verlaten: POST naar /cart/add.js, daarna de winkelwagenlade
      (cart:refresh en CartDrawer.open, zoals assets/product-section.js). Lukt dat niet of is er geen lade, dan
      gaat het formulier gewoon naar /cart. GA4 add_to_cart komt uit assets/ga4-ecommerce.js (fetch-onderschepping).
   3. Balk onderaan op mobiel: zichtbaar zodra de knop in de bestelkaart uit beeld is, weg bij de bedragen en het
      slot (daar staan al knoppen). Op desktop verbergt de CSS hem.
   Geen persoonsgegevens, geen opslag. */
(function () {
  'use strict';
  var root = document.querySelector('[data-ckp]');
  if (!root) return;

  // 1. Bedragkeuze
  var keuze = root.querySelector('[data-ckp-keuze]');
  if (keuze) {
    var zet = function (r) {
      var bedrag = root.querySelector('[data-ckp-kaart-bedrag]');
      if (bedrag) bedrag.textContent = r.getAttribute('data-prijs-kort');
      var bonus = r.getAttribute('data-bonus');
      var kaart = root.querySelector('[data-ckp-kaart-bonus]');
      if (kaart) {
        kaart.hidden = !bonus;
        var kb = kaart.querySelector('[data-ckp-kaart-bonusbedrag]');
        if (kb) kb.textContent = r.getAttribute('data-bonus-kort');
      }
      var som = root.querySelector('[data-ckp-som]');
      if (som) {
        som.hidden = !bonus;
        Array.prototype.forEach.call(som.querySelectorAll('[data-ckp-prijs]'), function (el) { el.textContent = r.getAttribute('data-prijs'); });
        var sb = som.querySelector('[data-ckp-bonus]');
        if (sb) sb.textContent = bonus;
      }
    };
    keuze.addEventListener('change', function (e) {
      if (e.target && e.target.name === 'id') zet(e.target);
    });
    var gekozen = keuze.querySelector('input[name="id"]:checked');
    if (gekozen) zet(gekozen);
  }

  // 2. In de winkelwagen
  Array.prototype.forEach.call(root.querySelectorAll('form[data-ckp-form]'), function (form) {
    form.addEventListener('submit', function (e) {
      if (typeof window.fetch !== 'function' || !window.CartDrawer) return;
      var veld = form.querySelector('input[name="id"]:checked') || form.querySelector('input[name="id"][type="hidden"]');
      var id = veld ? parseInt(veld.value, 10) : 0;
      if (!id) return;
      e.preventDefault();
      var knop = form.querySelector('[type="submit"]');
      var tekst = knop ? knop.textContent : '';
      if (knop) { knop.disabled = true; knop.textContent = 'Bezig...'; }
      window.fetch('/cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({id: id, quantity: 1})
      }).then(function (r) {
        if (!r.ok) throw new Error('HTTP ' + r.status);
        return r.json();
      }).then(function () {
        if (knop) { knop.textContent = 'Toegevoegd ✓'; knop.classList.add('is-toegevoegd'); }
        var live = document.getElementById('AjaxLiveRegion');
        if (live) live.textContent = 'Cadeaukaart toegevoegd aan winkelwagen';
        document.dispatchEvent(new CustomEvent('cart:refresh'));
        window.CartDrawer.open();
        setTimeout(function () {
          if (knop) { knop.textContent = tekst; knop.classList.remove('is-toegevoegd'); knop.disabled = false; }
        }, 2000);
      }).catch(function () {
        // Terugval: het gewone formulier, naar /cart.
        if (knop) { knop.textContent = tekst; knop.disabled = false; }
        form.submit();
      });
    });
  });

  // 3. Balk onderaan op mobiel
  var balk = root.querySelector('[data-ckp-balk]');
  var hoofdknop = root.querySelector('[data-ckp-hoofdknop]');
  if (balk && hoofdknop && 'IntersectionObserver' in window) {
    balk.hidden = false;
    var zichtbaar = {hoofd: true, bedragen: false, slot: false};
    var werkBij = function () {
      balk.classList.toggle('is-zichtbaar', !zichtbaar.hoofd && !zichtbaar.bedragen && !zichtbaar.slot);
    };
    var kijk = function (el, sleutel) {
      if (!el) return;
      new IntersectionObserver(function (items) {
        zichtbaar[sleutel] = items[0].isIntersecting;
        werkBij();
      }).observe(el);
    };
    kijk(hoofdknop, 'hoofd');
    kijk(root.querySelector('#bedragen'), 'bedragen');
    kijk(root.querySelector('[data-ckp-slot]'), 'slot');
  }
})();
